var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGenericCurrencyWhite = function SvgGenericCurrencyWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10.5 10.15c0 1.417 1.219 2.566 2.722 2.566h2.722c1.504 0 2.723-1.149 2.723-2.566 0-1.418-1.22-2.567-2.723-2.567h-2.722c-1.503 0-2.722-1.149-2.722-2.567 0-1.417 1.219-2.566 2.722-2.566h2.722c1.504 0 2.723 1.149 2.723 2.566m-4.084-3.85V14M11.667 16.552a5.414 5.414 0 0 0-3.61-1.386c-3.08 0-5.578 2.612-5.578 5.834 0 3.221 2.497 5.833 5.578 5.833a5.414 5.414 0 0 0 3.61-1.385m-10.5-3.076h6.562m-6.562-2.745h6.562M25.667 26.833H17.5s2.599-1.893 2.599-4.804c0-1.94-1.55-2.634-1.572-4.251.002-3.201 4.17-3.031 5.62-1.759M17.5 22.03h6.31"
  })));
};
export default SvgGenericCurrencyWhite;